export const isBuildProduction = process.env.NODE_ENV === 'production';
